import { render, staticRenderFns } from "./general.vue?vue&type=template&id=1e67ec58&scoped=true&"
import script from "./general.vue?vue&type=script&lang=js&"
export * from "./general.vue?vue&type=script&lang=js&"
import style0 from "./general.vue?vue&type=style&index=0&id=1e67ec58&prod&lang=scss&"
import style1 from "./general.vue?vue&type=style&index=1&id=1e67ec58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e67ec58",
  null
  
)

export default component.exports